var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createIwa } from '@cognitranlimited/itis-web';
import { createRoot } from 'react-dom/client';
import { ktiscProps } from './ktiscProps';
import './ktisc.scss';
import 'core-js/es/symbol';
var Iwa = createIwa();
var container = document.getElementById('root');
var root = container && createRoot(container);
root === null || root === void 0 ? void 0 : root.render(_jsx(Iwa, __assign({}, ktiscProps())));
